<template>
  <div id="energy-supply-view">
    <div class="vx-col w-full mb-base">
      <vx-card ref="infoCard" :title="cardTitle" title-color="black">
        <vs-row vs-type="flex" vs-justify="flex-end">
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
            <vs-button type="border" class="mr-3" icon-pack="feather" icon="icon-save" @click="saveData" v-if="selectedTab==0">{{ $t('Save') }}</vs-button>
            <vs-button type="border" class="mr-3" color="danger" @click="returnToList">{{ $t('Cancel') }}</vs-button>
          </vs-col>
        </vs-row>
        
          <vs-tabs v-model="selectedTab" :key="tabsKey">
            <vs-tab value="0" :label="$t('Decarbonization.EnergySupplyTemplate.Tab1Title')" icon-pack="feather" icon="icon-settings">
              <ValidationObserver ref="observer">
                <div class="p-6">
                  <vs-row class="mb-3">
                    <vs-col vs-w="6" class="mr-5">
                      <vs-row class="mb-3">
                        <vs-col vs-w="6">
                          <ValidationProvider :name="$t('Decarbonization.EnergySupplyTemplate.Name')" rules="required" v-slot="{ errors }">
                            <validated-input
                              :label="$t('Decarbonization.EnergySupplyTemplate.Name')"
                              v-model="name"
                            ></validated-input>
                            <validation-message>{{ errors[0] }}</validation-message>
                          </ValidationProvider>
                        </vs-col>
                      </vs-row>
                    </vs-col>               
                  </vs-row>
                </div>
              </ValidationObserver>
            </vs-tab>
            <vs-tab :disabled="id === 0"  value="1" :label="$t('Decarbonization.EnergySupplyTemplate.Tab2Title')" icon-pack="feather" icon="icon-calendar" v-b-tooltip.hover :title="id === 0 ? $t('Decarbonization.EnergySupplyTemplate.Tab2Unavailable') : ''">
                <yearly-ratios
                  ref="yearlyRatios"
                  :yearlyRatios="yearlyRatios"
                  :templateId="id"
                  @onRebindYearlyRatios="bindYearlyRatios"
                />
            </vs-tab>
          </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>

<script>

import YearlyRatios from './components/YearlyRatios.vue'
import module from "../../store/module.js";
import {
  ValidatedInput,
  ValidationMessage
} from "../../../../shared/components";

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    YearlyRatios
  },
  data() {
    return {
      id: 0,
      name : '',      
      selectedTab: 0,
      yearlyRatios: [],
      tabsKey: 0
    };
  },
  watch: {
  },
  computed: {
    cardTitle()  {
      if (this.id !== null && this.id > 0)
        return this.name;
      else
        return this.$t('Decarbonization.EnergySupplyTemplate.AddNew');
    }
  },
  created() {
    if (!module.isRegistered) {
      this.$store.registerModule("decarbonization", module);
      module.isRegistered = true;
    }
    if (this.$route.params.editData !== undefined && this.$route.params.editData !== null) {
      this.id = this.$route.params.editData.id;
      this.refreshModel();
    }
    else {
      this.initValues();
    }
  },
  mounted() {
  },

  methods: {
    refreshModel() {
      this.$cqrsGet("cashflow/decarbonization/energySupplyTemplates/find/", { params : { id: this.id }})
        .then((response) => {
          this.id = response.data.model.id;
          this.name = response.data.model.name;          
          this.yearlyRatios = response.data.model.yearlyRatiosBySource;
        })
        .finally(() => {
          this.$refs.infoCard.removeRefreshAnimation()
        });
    },
    initValues() {
      if (this.data) return;
      this.id = 0;
      this.name = "";
      this.selectedTab = 0;
      this.yearlyRatios = [];
    },
    saveData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          this.$vs.loading();
          const energySupplyTemplate = {
            id: this.id,
            name: this.name
          };
          if (this.id !== null && this.id > 0) {
            this.$cqrsPost('cashflow/decarbonization/energySupplyTemplates/edit', { energySupplyTemplate })
              .then((response) => {
                this.$notifySaveSuccess();
                this.yearlyRatios = response.data.model.yearlyRatiosBySource;
              })
              .finally(() => {
                this.$vs.loading.close();
              });
          } else {
            this.$cqrsPost('cashflow/decarbonization/energySupplyTemplates/create', { energySupplyTemplate })
              .then((response) => {                
                this.$notifySaveSuccess();
                this.id = response.data.model.id;
                this.yearlyRatios = response.data.model.yearlyRatiosBySource;
              })
              .finally(() => {
                this.selectedTab = 2;
                this.forceRefreshTabs();
                this.$vs.loading.close();
              });
          }
        }
      });
    },
    returnToList() {
      this.$router.push({ name: 'BSG-decarbonization-admin-energySupplyTemplates'});
    },
    bindYearlyRatios(model) {
      this.yearlyRatios = model;
    },
    forceRefreshTabs() {
      this.tabsKey++;
    }
  }
};
</script>
